import { render, staticRenderFns } from "./ObjectStoreSelectButtonPopover.vue?vue&type=template&id=e604b34a"
import script from "./ObjectStoreSelectButtonPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreSelectButtonPopover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports